import { DownloadOutlined } from "@ant-design/icons";
import { ReactElement } from "react";
import { UI_ModuleDocuments } from "../../../../UI_ITO/indexUI";
import { useAppSelector } from "../../../../store/reduxHooks";
import { SELECT_PROFILE_ROLE } from "../../../../store/selectors/profileSelectors";
import { SELECT_REQUEST_DOCUMENTS } from "../../../../store/selectors/requestAppSelector";
import {
  Document,
  DocumentType,
} from "../../../../store/slice/requestAppSlise/requestAppSlise";
import { DownloadingFiles } from "../../../../utils/utilities/Downloads";

import classes from "../../BankAgent/style/BankInfom.module.css";

export function DocForCredit(): ReactElement {
  const documents = useAppSelector(SELECT_REQUEST_DOCUMENTS);
  const role = useAppSelector(SELECT_PROFILE_ROLE);

  return (
    <div className={classes.documentListContainer}>
      <div className={classes.documentList}>
        {Array.isArray(documents) &&
          documents?.map((item: DocumentType<Document>) => {
            const { document } = item;
            const key = item.id;
            return (
              <div
                key={key}
                className={
                  item.document ? classes.documentCard : classes.documentEmpty
                }
                onClick={() => {
                  if (item.document && role !== "manager") {
                    DownloadingFiles({
                      url: `auth/file/${item.document.id}`,
                      fileName: `${item.document.name}`,
                    });
                  }
                }}
              >
                <UI_ModuleDocuments
                  title={item.name}
                  titleDown={
                    document?.name ? document?.name : "Документ не загружен"
                  }
                  icon={
                    role !== "manager" && (
                      <DownloadOutlined style={{ color: "black" }} />
                    )
                  }
                />
              </div>
            );
          })}
      </div>
    </div>
  );
}
